import format from 'date-fns/format'
import { RequestParams } from '../../../store/heatmap/reducer'
import { CropTypeRecord } from '../../../store/api/api'

export const transformHeatmapParams = (values: RequestParams, cropTypes?: CropTypeRecord[]) => ({
  ...values,
  varietyType: cropTypes?.find((ct) => ct.label === values.varietyType[0])?.value || '',
  date: format(new Date(values.date), 'yyyy-MM-dd')
})
